import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { SmsRateLimitsResponse } from 'voxloud-types/dist/models';

@Component({
  selector: 'fraud-rate-limits-popup',
  templateUrl: './fraud-rate-limits-popup.component.html',
  styleUrls: ['./fraud-rate-limits-popup.component.scss']
})
export class FraudRateLimitsPopupComponent implements OnInit {
  public fraudRateLimitForm: UntypedFormGroup;
  public smsRateLimits: SmsRateLimitsResponse;
  @Output() onEmitFraudRateLimits: EventEmitter<object> = new EventEmitter();

  constructor(private fb: UntypedFormBuilder,
    private activeModal: NgbActiveModal) { }

  ngOnInit(): void {
    const createControl = (value: any) => {
      const control = new UntypedFormControl(value, [
        Validators.required,
        Validators.pattern(/^\d+$/),
        Validators.min(2)
      ]);
      control.markAsTouched();
      control.markAsDirty();
      return control;
    };

    this.fraudRateLimitForm = this.fb.group({
      accountRate: createControl(this.smsRateLimits?.company_rate_limit?.requests),
      identicalMessageRate: createControl(this.smsRateLimits?.content_rate_limit?.requests)
    });
  }

  get accountRate() {
    return this.fraudRateLimitForm && this.fraudRateLimitForm.get('accountRate');
  }

  get identicalMessageRate() {
    return this.fraudRateLimitForm && this.fraudRateLimitForm.get('identicalMessageRate');
  }

  public sendRequest(): void {
    this.onEmitFraudRateLimits.emit(this.fraudRateLimitForm.value);
    this.close();
  }

  public isRateLimitsUnchanged(): boolean {
    return !(this.smsRateLimits?.company_rate_limit?.requests !== +this.fraudRateLimitForm.get('accountRate')?.value || this.smsRateLimits?.content_rate_limit?.requests !== +this.fraudRateLimitForm.get('identicalMessageRate')?.value);
  }

  public close(): void {
    this.activeModal.close('close');
  }
}
